import { render, staticRenderFns } from "./AdvertenciaGuardarComoPresupuesto.vue?vue&type=template&id=04ba886c&"
import script from "./AdvertenciaGuardarComoPresupuesto.vue?vue&type=script&lang=js&"
export * from "./AdvertenciaGuardarComoPresupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports